export default "__VITE_ASSET__617ae758__"